import { RequiredModelMetadata } from '@mri-platform/shared/core';
import { EntityMetadataMap } from '@ngrx/data';
import { toDictionary } from '@rx-angular/cdk/transformations';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createEntityMetadataMap = (...entities: RequiredModelMetadata<any>[]): EntityMetadataMap =>
  toDictionary(entities, 'entityName');
